module.exports = __webpack_public_path__ + "static/media/black-cancel.4f798678.svg";